import React, {Component} from 'react'
import './styles.css'
import {Formik, Field, Form} from 'formik'
import Header from '../../components/header'
import util from '../../classes/util'
import {PRECISA_LOGAR} from '../../config'
import {connect} from 'react-redux'
import { Redirect } from 'react-router-dom'
import Image from 'react-bootstrap/Image'
import { apiEmployee } from '../../services/apiamrg'
import moment from 'moment'

const estadoInicial = {
    nome: '',
    descricao: '',
    data: '',
    porto: 0,
    thumb: [],
    imagem: '',
    terminal: [],
    id: null,
    seaports: [],
    redirect: false,
    finalizaOperacao: false,
    spanerror1:'',
    spanerror2:'',
    spanerror3:'',
    spanerror4:'',
    maxTerminal: null

}

class AddTerminal extends Component {
    
    state = {
        ...estadoInicial
    }

    componentDidMount = async () => {
        window.scrollTo(0, 0)
        var id = await this.props.match.params.id
        await this.setState({id})
        if(parseInt(id) !== 0){
            await this.setState({terminal: this.props.location.state.terminal})
            console.log('Terminais: ' + JSON.stringify(this.state.terminal))
            await this.loadData(this.state.terminal)
        }
        console.log(this.props.token)
        this.getSeaports()
    }

    getSeaports = async () => {
        await apiEmployee.post(`getSeaports.php`, {
            token: this.props.token
        })
        .then(
            async response => { 
                await this.setState({seaports: response.data})
                await this.setState({loading: false})
            },
            response => {this.erroApi(response)}
        )
    }

    loadData = async (produto) => {
        console.log(produto)
         await this.setState({maxTerminal: produto.id, nome: produto.nome, descricao: produto.descricao, porto: produto.porto})
         await this.setState({thumb: [...this.state.thumb, `http://ftptrade.ddns.net/amrg/api/pictures/${produto.imgs}`]})
         console.log(produto.nome)
    }

    getMaxTerminal = async () => {
        console.log('get news')
        await apiEmployee.post('getMaxTerminal.php', {
            token: this.props.token
        }).then(
            async res => {
                await this.setState({maxTerminal: res.data[0].id})
                //console.log(this.state.maxNews)
            },
            async err => alert('erro: ' + err)
        )
    }

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
    });

    salvarFoto = async () => {
        console.log('salvar foto')
        let result = await this.toBase64(this.state.imagem)
        let id_terminal = 'TERMINAIS_' + util.completarZerosEsquerda(`${this.state.maxTerminal}`, 6)
        await apiEmployee.post('insertTerminalPicture.php', {
            token: this.props.token,
            id_terminal: this.state.maxTerminal,
            nome: id_terminal,
            picture: result
        }).then(
            async res => {
                console.log(res.data)
                if(res.data != 'false'){
                    alert('Terminal Inserido!')
                     await this.setState({finalizaOperacao: true})
                }else{
                    alert('Erro, tente novamente!')
                }
            },
            err => alert(err)
        )         
    }
   
    salvarNews = async () => {
        //this.getMaxNews()
        
        if(parseInt(this.state.id) === 0){
            console.log('novo Terminal')
            //$cols = 'data, titulo, texto, imagem, link, inativo';
            await apiEmployee.post(`insertTerminal.php`, {
                token: this.props.token,
                values: `'${this.state.nome}', '${this.state.descricao}', '${this.state.porto}'` 
            }).then(
                async res => {
                    if(JSON.stringify(res.data) == 'true'){
                        await this.getMaxTerminal()
                        if(this.state.maxTerminal > 0){
                            await this.salvarFoto()
                        }
                        //alert('Terminal Inserido!')
                        //await this.setState({finalizaOperacao: true})
                    }else{
                        alert(`Erro: ${res.data}`)
                    }    
                },
                async res => await alert(`Erro: ${res.data}`)
            )
       }else{
           console.log('alterar noticia')
           if(this.state.imagem != null && this.state.imagem != '')  {
            await this.salvarFoto();
      }
           await apiEmployee.post(`updateTerminal.php`, {
               token: this.props.token,
               id_terminal: this.state.id,
               nome: this.state.nome,
               descricao: this.state.descricao,
               porto: this.state.porto
           }).then(
            async res => {
                
                console.log(res.data)
                if(res.data === true){
                    await alert(`Terminal alterado`)
                    await this.setState({finalizaOperacao: true})
                }else{
                    await alert(`Erro`)
                }
            },
            async res => await alert(`Erro: ${res.data}`)
           )
           
       }
       
   }

    erroApi = async (res) => {
        alert(PRECISA_LOGAR)
        await this.setState({redirect: true})
    }

    limpaControles = async () => {
        await this.setState({name: ''})
    }

    fileSelectedHandler = async (event) => {
        console.log(event.target.files[0])
        await this.setState(
            {
                thumb: [URL.createObjectURL(event.target.files[0])], 
                imagem: event.target.files[0]
            }
        )
        console.log('fotos: ' + this.state.imagem)
    }

    removerFoto = async (indice) => {
        await this.setState({imagem: [], thumb: []})      
    }

    verificadorspans = () => {
        if(this.state.nome && this.state.nome.trim().length >= 3){
            this.setState({spanerror1:''})
        }else{
            this.setState({spanerror1:'Nome Invalido'})
        }
        if(this.state.descricao && this.state.descricao.trim().length >= 10) {
            this.setState({spanerror2:''})
        }else {
            this.setState({spanerror2:'Minimo 10 caracteres para a descricao'})
        }
        if(this.state.porto && this.state.porto > 0){
            this.setState({spanerror3:''})
        }else  {
            this.setState({spanerror3:'Não selecionado'})
        }
        if(this.state.thumb[0] != null){
            this.setState({spanerror4:''})
        }else  {
            this.setState({spanerror4:'Imagem não carregada'})
        }
    }
    tirarnumeros = (a) => {
            this.setState({nome: a})
    }








    render(){
        
        const validations = []
        validations.push(this.state.nome && this.state.nome.trim().length >= 3)
        validations.push(this.state.descricao && this.state.descricao.trim().length >= 10)
        validations.push(this.state.porto && this.state.porto > 0)
        validations.push(this.state.thumb[0] != null)
        //o formulário só será válido se todas as validações forem verdadeiras, com este reduce implementado
        const validForm = validations.reduce((t, a) => t && a)
        
        return (
            <div>
                
                {this.state.redirect &&
                    <Redirect to={'/admin'} />
                }
                
                {this.state.finalizaOperacao &&
                    <Redirect to={'/admin/terminais'} />
                }
                
                <section className="page-add">
                    <Header voltarTerminal/>
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-8">
                                <div className="page-breadcrumb">
                                    <h2 style={{marginBottom: '3%', marginTop: '3%'}}>{parseInt(this.state.id) === 0 ? 'Inserir novo Terminal' : 'Alterar Terminal'}</h2>
                                </div>
                            </div>
                            <div className="col-2"></div>
                        </div>
                </section>

                <div className="contact-section">
                    
                        <div className="row">
                            <div className="col-lg-12">
                                <Formik 
                                initialValues={{
                                    name: '',
                                }}
                                onSubmit={async values => {
                                    await new Promise(r => setTimeout(r, 1000))
                                    this.salvarNews()
                                }}
                                >
                                    <Form className="contact-form" onBlur={() => {this.verificadorspans()}} >

                                    <div className="row">
                                        <div className="col-2"></div>
                                        
                                        <div className="col-8 ">
                                            
                                            <div className="row">
                                                
                                                <div className="col-2">
                                                    <label htmlFor="name">Nome</label>
                                                </div>
                                                <div className="col-10">    
                                                    <Field className="form-control" name="name" id="name" type="text" value={this.state.nome} onChange={async e => {  this.tirarnumeros(e.currentTarget.value)}}/>
                                                    <span className='spanerror'>{this.state.spanerror1}</span>
                                                </div>

                                                <div className="col-2">
                                                    <label htmlFor="descricao">Descrição</label>
                                                </div>

                                                <div className="col-10">
                                                    <textarea 
                                                        className="form-control" 
                                                        value={this.state.descricao} 
                                                        rows={4}
                                                        name="descricao"
                                                        id="descricao"
                                                        onChange={async e => { await this.setState({descricao: e.currentTarget.value})}} 
                                                    />
                                                    <span className='spanerror'>{this.state.spanerror2}</span>
                                                </div>
                                                <div className="col-2">
                                                    <label htmlFor="seaport">Porto</label>
                                                </div>
                                                <div className="col-10">
                                                    <select 
                                                        className="form-control" 
                                                        as="select" 
                                                        name="seaport" 
                                                        id="seasport" 
                                                        value={this.state.porto} 
                                                        onChange={async e => { await this.setState({porto: e.currentTarget.value})}}>
                                                        <option value={0}>Escolha um porto...</option>
                                                        {this.state.seaports.map(seaport => (
                                                            <option key={seaport.id} value={seaport.id}>{seaport.name}</option>
                                                        ))}
                                                    </select>
                                                    <span className='spanerror'>{this.state.spanerror3}</span>
                                                </div>

                                            </div>

                                            <div className="col-2">
                                                    <label htmlFor="file">Imagem</label>
                                                </div>
                                                <div className="col-10">
                                                    <input type="file" name="file" className="form-control-lg" accept="image/png" onChange={this.fileSelectedHandler}/>
                                                    <span className='spanerror'>{this.state.spanerror4}</span>  
                                                
                                                    </div>
                                                <div className="col-2">
                                             
                                             </div>
                                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                                    <img src={this.state.thumb[0]} thumbnail fluid style={{maxHeight: 200, maxWidth: 200}}/> 
                                                </div>
                                                <div className="col-12">
                                             
                                                </div>

                                        </div>
                                         <div className="col-2"></div>
                                    </div>
                                    
                                    <div className="row">
                                        <div className="col-2"></div>
                                        <div className="col-8" style={{display:'flex',justifyContent:'center'}}>
                                            <button disabled={!validForm} type="submit" style={validForm ? {width:300} : {backgroundColor: '#eee', opacity: 0.3, width:300} } >{parseInt(this.state.id) === 0 ? 'Salvar' : 'Alterar'}</button>
                                        </div>
                                        <div className="col-2"></div>
                                    </div>

                                    </Form>
                                </Formik>
                            </div>
                        </div>
                    
                </div>
            </div>
        )
        
    }
}

const mapStateToProps = ({user, servidor}) => {
    return{
        token: user.token,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(AddTerminal)
    
